import { useMutation } from 'react-query';

import { createActivityCodeAlias as mutationFn } from 'api/endPoints/createActivityCodeAlias';

export const useMutationCreateAlias = () => {
    return useMutation<any, QueryError, CreateAliasProps>((params) => mutationFn(params));
};

interface CreateAliasProps {
    alias: string;
    contractId: number | undefined;
    name: string;
    scope: string;
}
